import type React from "react";
import { Button } from "senf-atomic-design-system";
import { cn } from "senf-atomic-design-system/src/util/classNameConstructor";

const TestEnvironmentToggle: React.FC = () => {
  const isDev = import.meta.env.VITE_APP_MODE === "development";
  if (!isDev) return null;

  const isOn =
    typeof localStorage !== "undefined" &&
    localStorage.getItem("test-environment") === "true";

  const handleToggle = () => {
    const next = !isOn;
    try {
      localStorage.setItem("test-environment", next ? "true" : "false");
    } catch {}
    setTimeout(() => window.location.reload(), 150);
  };

  return (
    <div className="fixed bottom-0 start-0 m-3 z-[2147483647]">
      <Button
        size="sm"
        variant="outline"
        onClick={handleToggle}
        tooltipLabel="Use `senf-copy` Firebase config (with copied production data)"
        className="bg-white"
        leadingIcon={
          <span
            className={cn(
              "inline-block h-3 w-3 ms-1 rounded-full shrink-0",
              isOn ? "bg-tag-surface-selected-green" : "bg-tag-surface-grey",
            )}
          />
        }
      >
        {isOn ? "Test Env: ON" : "Test Env: OFF"}
      </Button>
    </div>
  );
};

export default TestEnvironmentToggle;
